import { useValues } from "2g-form/hooks";

export default function useRezervaceVytvoreniProdukt() {
  const values = useValues() || {};

  return {
    typZdroje: values.typZdroje,
    zdroj: values.zdroj,
    produkt: values.produkt,
    isVisible: Boolean(values.projekt)
  };
}
